module.exports = __webpack_public_path__ + "static/media/70.6403f42d.jpg";